const retailerLogos = [
{ src: "https://customer-assets.emergentagent.com/job_lmt-product-strategy/artifacts/90onnzvg_Sainsburys_logo_PNG2.png", alt: "Sainsbury's", scale: 1.8 },
{ src: "https://customer-assets.emergentagent.com/job_lmt-product-strategy/artifacts/r0ym961a_Primark_logo_2024.png", alt: "Primark", scale: 0.5 },
{ src: "https://customer-assets.emergentagent.com/job_lmt-product-strategy/artifacts/zietla0o_Kmart_Australia-Logo.wine.png", alt: "Kmart", scale: 1.8 },
{ src: "https://customer-assets.emergentagent.com/job_lmt-product-strategy/artifacts/vc2dd7gu_Target_Australia-Logo.wine.png", alt: "Target", scale: 1.6 },
{ src: "https://customer-assets.emergentagent.com/job_lmt-product-strategy/artifacts/ge0cvdc5_Dollarama-Logo.wine.png", alt: "Dollarama", scale: 1.8 },
{ src: "https://customer-assets.emergentagent.com/job_lmt-product-strategy/artifacts/me4tmw3p_Action_%28store%29-Logo.wine.png", alt: "Action", scale: 1.8 }];


const projects = [
{
  title: "Spark Studio",
  subtitle: "Brand identity / packaging / visual system",
  image: "https://customer-assets.emergentagent.com/job_lmt-product-strategy/artifacts/rm2zivmv_Kittycorn.jpg"
},
{
  title: "Retail Narrative",
  subtitle: "Category positioning / range architecture",
  image: "https://customer-assets.emergentagent.com/job_lmt-product-strategy/artifacts/16mb97mn_Glow%20and%20Gooo.jpg"
},
{
  title: "Packaging Architecture",
  subtitle: "Packaging design / brand strategy",
  image: "https://customer-assets.emergentagent.com/job_lmt-product-strategy/artifacts/xobutav6_Zombites%20Product_V2.jpg"
}];


// Duplicate for seamless infinite loop on all screen sizes
const duplicated = [...projects, ...projects, ...projects, ...projects];

export const FeaturedWork = () => {
  return (
    <section id="work" data-testid="featured-work-section" className="py-24 md:py-32 bg-off-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-12 md:mb-16">
        <span className="font-body text-xs uppercase tracking-[0.2em] text-charcoal/50 block mb-4">
          Featured Work
        </span>
        <h2
          data-testid="featured-work-heading"
          className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-[-0.02em] text-deep-black font-light">Trusted by


        </h2>
      </div>

      {/* Marquee */}
      <div className="relative" data-testid="featured-work-marquee">
        <div className="marquee-track">
          {duplicated.map((project, i) =>
          <div
            key={`${project.title}-${i}`}
            data-testid={`featured-card-${i}`}
            className="flex-shrink-0 w-[340px] sm:w-[420px] md:w-[520px] group cursor-pointer">

              <div className="img-zoom rounded-2xl overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.06)] aspect-[4/5]">
                <img
                src={project.image}
                alt={project.title}
                className="w-full h-full object-cover"
                loading="lazy" />

              </div>
              <div className="mt-5 px-1">
                <h3 className="font-heading text-lg md:text-xl text-deep-black tracking-tight font-medium group-hover:translate-x-1 transition-transform duration-300">
                  {project.title}
                </h3>
                <p className="font-body text-sm text-charcoal/50 mt-1 font-light tracking-wide">
                  {project.subtitle}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Retailer Logo Strip */}
      <div className="mt-16 overflow-hidden" data-testid="retailer-logo-strip">
        <div className="logo-marquee-track">
          {[...retailerLogos, ...retailerLogos, ...retailerLogos, ...retailerLogos].map((logo, i) =>
          <div key={`logo-${i}`} className="flex-shrink-0 w-[180px] flex items-center justify-center">
              <img
              src={logo.src}
              alt={logo.alt}
              className="h-12 md:h-14 w-auto object-contain"
              style={{ filter: 'invert(1) grayscale(1) contrast(3) brightness(0.8)', transform: `scale(${logo.scale})` }}
              loading="lazy" />

            </div>
          )}
        </div>
      </div>
    </section>);

};